import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

// import PropTypes from "prop-types";
import { swalConfirm, sweatalert } from "../../../../component/Sweatalert2";
import { ClientnoteGridViewApi, clientnoteDeleteApi, clientnoteLockApi, clientnoteUnlockApi, openAddNoteForm, openEditNoteForm, clientnoteDetailApi } from "store/slices/clientnoteSlice";
import config from "../../../../config";
import InfiniteScroll from "react-infinite-scroll-component";
import PaginationLoader from "component/PaginationLoader";
import NoteFormDrawer from "./NoteFormDrawer";
import BarLoader from "react-spinners/BarLoader";
import { clientNoteDate, clientNoteEditedDate } from "./clientNoteDate";
import { isClientNoteLocked, unlockedClientNotes } from "./clientNoteForm";

import { isRichClientNote, sanitizeClientNoteHtml } from "./clientNoteRichText";

const Notes = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [OpenConfirm, SetOpenConfirm] = useState(false);
  const [deletingAll, setDeletingAll] = useState(false);
  const [bulkDeleteError, setBulkDeleteError] = useState("");
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  void (currentUser && currentUser.role_id);
  useSelector(state => state.salonmodule.isAccess);

  const noteViews = useSelector((state) => state.clientnote.isGridView);
  const noteListError = useSelector((state) => state.clientnote.isGridViewError);
  const isApiStatus = useSelector((state) => state.clientnote.isApiStatus);
  const detail = useSelector((state) => state.client.isDetailData);

  const fetchDataPhotoList = () => {
    dispatch(ClientnoteGridViewApi({ client_id: detail.id, next_page_url: noteViews.next_page_url }));
  };

  const [isFetching, setIsFetching] = useState(false);
  const loadMoreItemsList = () => {
    setIsFetching(true);
    dispatch(ClientnoteGridViewApi({ next_page_url: noteViews && noteViews.next_page_url, client_id: detail.id }));
    //mocking an API call
    setTimeout(() => {
      setIsFetching(false);
    }, 2000);
  };

  const handleDeleteAllNotes = async () => {
    if (deletingAll || !detail?.id) return;
    setDeletingAll(true);
    setBulkDeleteError("");
    try {
      // Collect every page before deleting so removals cannot shift later pages.
      const notes = new Map();
      const seenPages = new Set();
      let nextPage;
      do {
        if (seenPages.has(nextPage)) throw new Error("Repeated notes page");
        seenPages.add(nextPage);
        const result = await dispatch(ClientnoteGridViewApi({ client_id: detail.id, next_page_url: nextPage }));
        if (result?.meta?.requestStatus !== "fulfilled") throw new Error("Unable to load notes");
        const page = result.payload;
        const rows = Array.isArray(page) ? page : page?.data;
        if (!Array.isArray(rows)) throw new Error("Invalid notes response");
        rows.forEach(note => {
          if (note.client_id == null || String(note.client_id) === String(detail.id)) notes.set(note.id, note);
        });
        nextPage = Array.isArray(page) ? null : page.next_page_url;
      } while (nextPage);
      const results = await Promise.allSettled(unlockedClientNotes([...notes.values()]).map(note =>
        Promise.resolve().then(() => dispatch(clientnoteDeleteApi({ id: note.id }))),
      ));
      const deleted = results.filter(result => result.status === "fulfilled" && result.value?.meta?.requestStatus === "fulfilled").length;
      const failed = results.length - deleted;
      await dispatch(ClientnoteGridViewApi({ client_id: detail.id }));
      if (failed) {
        setBulkDeleteError(`${deleted} ${t("notes deleted")}; ${failed} ${t("notes could not be deleted. Please retry.")}`);
      } else {
        SetOpenConfirm(false);
      }
    } catch (error) {
      setBulkDeleteError(t("Unable to delete all notes. Please retry."));
    } finally {
      setDeletingAll(false);
    }
  };

  const handleClientDelete = (e) => {
    const event = JSON.parse(e.currentTarget.dataset.obj);
    let confirmbtn = swalConfirm(e.currentTarget, { title: t("Are you sure want to delete?"), message: t("Success"), confirmButtonText: t("Yes, delete it!") });
    if (confirmbtn == true) {
      dispatch(clientnoteDeleteApi({ id: event.id }));
    }
  };

  const handleNoteEditForm = (e) => {
    const id = e.currentTarget.closest(".event-box").dataset.id;
    dispatch(openEditNoteForm());
    dispatch(clientnoteDetailApi({ id, client_id: detail.id }));
  };

  const handleNoteLock = (e) => {
    const event = JSON.parse(e.currentTarget.dataset.obj);
    const action = isClientNoteLocked(event) ? clientnoteUnlockApi : clientnoteLockApi;
    dispatch(action({ id: event.id })).then((result) => {
      if (result.meta.requestStatus === "rejected") {
        sweatalert({ title: t("Unable to update the note lock. Please try again."), icon: "error" });
      }
    });
  };
  return (
    <>
      <div className="drawer-header">
        <h2 className="mb-4 pe-md-5 mb-lg-5">
          {t("Notes")}{" "}
          <button type="button" className="btn btn-outline-primary btn-sm ms-2" onClick={() => dispatch(openAddNoteForm())}>
            {t("Add Note")}
          </button>
          {noteViews && noteViews.data && unlockedClientNotes(noteViews.data).length > 0 && (
            <button type="button" className="btn btn-apricots  btn-sm ms-2" onClick={() => SetOpenConfirm(true)}>
              {t("Delete All Note")}
              {isApiStatus && isApiStatus.clientnoteDeleteApi === "loading" && <BarLoader color="#8c1c4d" className="d-flex align-items-end" />}
            </button>
          )}
        </h2>
      </div>
      {noteListError && (
        <div className="alert alert-danger mb-3" role="alert">
          {noteListError}
          <button type="button" className="btn btn-outline-primary btn-sm ms-2" onClick={() => dispatch(ClientnoteGridViewApi({ client_id: detail.id }))}>
            {t("Retry")}
          </button>
        </div>
      )}
      <div className="content-wrp" id="notelist">
        {OpenConfirm && (
          <>
            <div className={OpenConfirm ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: OpenConfirm ? "block" : "none" }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-body pb-0">
                    <div className="p-3">
                      <h5 className="mb-3 fw-semibold text-dark">{t("Confirm All Note deletion")}</h5>
                      <p className="fw-semibold mb-2">{t("Are you sure you want to delete all Notes?")}</p>
                      {bulkDeleteError && <p role="alert" className="text-danger">{bulkDeleteError}</p>}
                    </div>
                    <div className="row mt-3 bg-cream p-4 justify-content-center">
                      <div className="col-6">
                        <button className="preview btn me-1 cursor-pointer btn-preview w-100" type="button" disabled={deletingAll} onClick={() => {
                          SetOpenConfirm(false);
                        }}>
                          {t("Cancel")}
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                          className="btn btn-primary w-100"
                          onClick={handleDeleteAllNotes}
                          disabled={deletingAll}
                          type="button"
                        >
                          {isApiStatus && isApiStatus.clientnoteDetailApi === "loading" && (<span className="spinner-border spinner-border-sm"></span>)}
                          {deletingAll ? t("Deleting…") : t("Confirm")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {OpenConfirm && <div className="modal-backdrop show"></div>}
          </>
        )}
        {noteViews && noteViews.data && noteViews.data.length > 0 ? (
          <InfiniteScroll className="row gx-0" dataLength={noteViews.data.length} next={fetchDataPhotoList} scrollableTarget="notelist" hasMore={noteViews.next_page_url ? true : false} loader={<PaginationLoader />}>
            {Object.keys(noteViews.data).map((item, i) => {
              let id = noteViews.data[item].id;
              //   let client_id = noteViews.data[item].client_id;
              let note = noteViews.data[item].note;
              const noteDates = clientNoteDate(noteViews.data[item], currentUser?.salon?.timezone) || t("Date unavailable");
              const editedDate = clientNoteEditedDate(noteViews.data[item], currentUser?.salon?.timezone);
              return (
                <div className="event-box" key={item && item.id ? item.id : i} data-id={id}>
                  <div className="row gx-1 justify-content-between">
                    <div className="col-md-7 mb-2">
                      <div><span>{t("Created")}:</span>{" "}<span>{noteDates}</span></div>
                      {editedDate && <div className="small text-muted">{t("Edited")}: {editedDate}</div>}
                    </div>
                    <div className="col-md-5 text-end mb-2">
                      {isClientNoteLocked(noteViews.data[item]) ? (
                        <>
                          <span className="badge bg-secondary me-2">{t("Locked")}</span>
                          <a className="cursor-pointer" data-obj={JSON.stringify(noteViews.data[item])} onClick={handleNoteLock}>
                            {t("Unlock")}
                          </a>
                        </>
                      ) : (
                        <>
                          <a className="remove me-2 cursor-pointer" data-obj={JSON.stringify(noteViews.data[item])} onClick={handleClientDelete}>
                            {t("Remove")}
                          </a>
                          <a className="btn btn-outline-primary btn-sm cursor-pointer" data-obj={JSON.stringify(noteViews.data[item])} onClick={(e) => handleNoteEditForm(e)}>
                            {t("Edit")}
                          </a>
                          <a className="ms-2 cursor-pointer" data-obj={JSON.stringify(noteViews.data[item])} onClick={handleNoteLock}>
                            {t("Lock")}
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                  {isRichClientNote(note) ? (
                    <div style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: sanitizeClientNoteHtml(note) }} />
                  ) : <p><b style={{ whiteSpace: "pre-wrap" }}>{note}</b></p>}
                </div>
              );
            })}
            {!isFetching && noteViews.next_page_url && (
              <div className="col-2 m-auto p-3 text-center">
                <button onClick={loadMoreItemsList} className="btn btn-primary">
                  {t("More")}
                </button>
              </div>
            )}
          </InfiniteScroll>
        ) : isApiStatus?.ClientnoteGridViewApi === "loading" ? (
          <p role="status">{t("Loading notes…")}</p>
        ) : noteListError ? null : (
          <div className="complete-box text-center d-flex flex-column justify-content-center mt-xl-4">
            <div className="complete-box-wrp text-center">
              <img src={config.imagepath + "nots.png"} alt="" className="mb-md-4 mb-3" />
              <h5 className="mb-2 fw-semibold">
                {t("Keep a note of anything you need to remember about your client.")}
                <br />
                <a className="add-note cursor-pointer" onClick={() => dispatch(openAddNoteForm())}>
                  {t("Add your first note.")}
                </a>
              </h5>
            </div>
          </div>
        )}
      </div>
      <NoteFormDrawer />
      {/* <NoteAddFormDrawer /> */}
    </>
  );
};

export default Notes;
